import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const e = t((c, o) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: o,
    ...c,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8c2.75 0 5.47.71 7.85 2.05.36.2.49.66.29 1.02s-.66.49-1.02.29A14.55 14.55 0 0 0 24 9.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24c0-2.73-.76-5.38-2.2-7.68a.747.747 0 1 1 1.27-.79C39.16 18.06 40 20.99 40 24c0 8.82-7.18 16-16 16"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M23.91 32.88h-.21c-2.42-.05-4.66-.97-6.12-2.53-.28-.3-.27-.78.03-1.06s.77-.27 1.06.03c1.19 1.27 3.04 2.02 5.06 2.06 2.19.03 4.24-.71 5.63-2.08.29-.29.77-.29 1.06.01s.28.77-.01 1.06c-1.64 1.6-4 2.51-6.5 2.51M30.55 24c-.35 0-.66-.25-.73-.6-.04-.19-.98-4.59-5.24-5.48a.74.74 0 0 1-.58-.89.74.74 0 0 1 .89-.58c2.88.6 4.52 2.48 5.42 4.09.84-3.41 3.05-9.29 8.59-12.45a.74.74 0 0 1 1.02.28c.21.36.08.82-.28 1.02-7.25 4.14-8.32 13.83-8.33 13.93a.75.75 0 0 1-.71.67c-.03.01-.04.01-.05.01"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "AgencySatisfiedIcon";
export {
  e as AgencySatisfiedIcon,
  e as default
};
//# sourceMappingURL=index.js.map
